import React, { Component } from 'react';
import Select from 'react-select';
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";
import Swal from "sweetalert2";
import { decodeData } from '../../Constants/constants';


// Sample blood group options
const bankAccountType = [
  { value: 'Current Account', label: 'Current Account' },
  { value: 'Saving Account', label: 'Saving Account' },
  { value: 'Fixed Deposit Account', label: 'Fixed Deposit Account' },
  { value: 'Recurring Deposit Account', label: 'Recurring Deposit Account' },
  { value: 'NRI Account', label: 'NRI Account' },
  // Add more options as needed
];
const salaryTransferMode = [
  { value: 'Cheques', label: 'Cheques' },
  { value: 'Demand Draft (DD)', label: 'Demand Draft (DD)' },
  { value: 'Cash payments', label: 'Cash payments' },
  { value: 'Digital wallets', label: 'Digital wallets' },
  { value: 'Unified Payments Interface (UPI)', label: 'Unified Payments Interface (UPI)' },
  // Add more options as needed
];

class EmployeeList extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);

    // Initial state to store form data and validation errors
    this.state = {
      name_As_Per_Bank_Record: '',
      enter_Bank_Name: '',
      account_Number: '',
      branch_Name: '',
      IFSC_code: '',
      account_Type: '',
      salary_Mode_Of_Trasfer: '',
      errors: {} ,// Store validation errors
      decodedData: [],
    };
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
           if (prevState.permissions !== this.context.permissions) {
                  // console.log("Permissions Updated:", this.context.permissions);
                const { permissions } = this.context;
                  if (permissions.length > 0) {
                      const queryParams = new URLSearchParams(window.location.search);
                      const encodedData = queryParams.get("abs");
                      const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                      if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                        this.setState({ decodedData });
                      }
                    } else {
                      console.warn("Permissions not yet available. Retrying...");
                    }
                }
      }

  // Handler function for form submission
  handleSubmit = (e) => {
    e.preventDefault();
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const employee_id = this.props.params.employee_id;
    var formData = {
      name_As_Per_Bank_Record: this.state.name_As_Per_Bank_Record,
      enter_Bank_Name: this.state.enter_Bank_Name,
      account_Number: this.state.account_Number,
      branch_Name: this.state.branch_Name,
      IFSC_code: this.state.IFSC_code,
      account_Type: this.state.account_Type,
      salary_Mode_Of_Trasfer: this.state.salary_Mode_Of_Trasfer,
    }
    console.log(formData);
    axios.post(`${apiURL}Employees/UpdateBankDetails`, formData, { headers }).then((response) => {
      console.log(response);

      const { success } = response.data;
      if (success === true) {
        this.setState({
          name_As_Per_Bank_Record: '',
          enter_Bank_Name: '',
          account_Number: '',
          branch_Name: '',
          IFSC_code: '',
          account_Type: '',
          salary_Mode_Of_Trasfer: '',
        })

        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          timer: 2000,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
      } else {
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          timer: 2000,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
      }

    })
  };
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Employees/GetEmployeeQualifications`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };
  handleDelete = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ status: true });
        const formData = {
          employee_qualification_id: id,
        };
        axios
          .post(`${apiURL}Employees/DeleteEmployeeQualification`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.success === true ? "Success" : "Failed"
                }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
            });
            this.setState({ status: false });
            if (response.data.success === true) {
              this.setState({ loadingList: true }, (prevState) => {
                this.GetList();
              });
            }
          })
          .catch((error) => {
            // Handle any errors that occur during the request
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
            });
          });
      }
    });
  };
  // Handler function to update state on input change
  handleInputChange = (e) => {
    const { name, value } = e.target;

    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  // Handler function for Select component change
  handleSelectChange = (name, selectedOption) => {
    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };



  // Custom validation function with regex
  validateForm = () => {
    const errors = {};

    // Validate individual fields
    if (!this.state.bloodGroup) {
      errors.bloodGroup = 'Blood Group is required';
    }

    if (!this.state.employeeCategory) {
      errors.employeeCategory = 'Employee Category is required';
    }

    if (!this.state.employeeType) {
      errors.employeeType = 'Employee Type is required';
    }

    if (!this.state.permanentAddress) {
      errors.permanentAddress = 'Permanent Address is required';
    }

    // Regex for valid 6-digit pin code
    const pinCodeRegex = /^[0-9]{6}$/;

    if (!this.state.pinCode) {
      errors.pinCode = 'Pin Code is required';
    } else if (!pinCodeRegex.test(this.state.pinCode)) {
      errors.pinCode = 'Invalid Pin Code. Must be a 6-digit number.';
    }

    // Add more validation rules as needed

    return errors;
  };

  render() {
    const { errors } = this.state;

    return (
      <div>
        <h5>
          Employee List{" "}
          <span
            style={{
              color: "blue",
              marginLeft: "5px",
              borderRadius: "50%",
              background: "#f0f8ff",
              padding: "2px 6px",
              display: "inline-block",
              textAlign: "center",
              width: "20px",
              height: "20px",
              lineHeight: "20px",
            }}
          >
            *
          </span>
        </h5>
        <p className="text-muted">
          Fill all information below
        </p>


        <div className="container mt-2">
          <form>



            {/* First Column */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="name_As_Per_Bank_Record" className="form-label">Name As Per Bank Record:</label>
                <input
                  type="text"
                  id="name_As_Per_Bank_Record"
                  name="name_As_Per_Bank_Record"
                  value={this.state.name_As_Per_Bank_Record}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.name_As_Per_Bank_Record ? 'is-invalid' : ''}`}
                  placeholder="Enter Your Name"
                  required
                />
                {errors.name_As_Per_Bank_Record && <div className="invalid-feedback">{errors.name_As_Per_Bank_Record}</div>}
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="enter_Bank_Name" className="form-label">  Bank Name:</label>
                <input
                  type="text"
                  id="enter_Bank_Name"
                  name="enter_Bank_Name"
                  value={this.state.enter_Bank_Name}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.enter_Bank_Name ? 'is-invalid' : ''}`}
                  placeholder="Enter Bank Name"
                  required
                />
                {errors.enter_Bank_Name && <div className="invalid-feedback">{errors.enter_Bank_Name}</div>}
              </div>
            </div>

            {/* Second Column */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="account_Number" className="form-label">Account Number:</label>
                <input
                  type="text"
                  id="account_Number"
                  name="account_Number"
                  value={this.state.account_Number}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.account_Number ? 'is-invalid' : ''}`}
                  placeholder="Enter Account Number"
                  required
                />
                {errors.account_Number && <div className="invalid-feedback">{errors.account_Number}</div>}
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="branch_Name" className="form-label">Branch Name:</label>
                <input
                  type="text"
                  id="branch_Name"
                  name="branch_Name"
                  value={this.state.branch_Name}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.branch_Name ? 'is-invalid' : ''}`}
                  placeholder="Enter Branch Name"
                  required
                />
                {errors.branch_Name && <div className="invalid-feedback">{errors.branch_Name}</div>}
              </div>
            </div>


            {/* Third Column */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="IFSC_code" className="form-label">IFSC code:</label>
                <input
                  type="text"
                  id="IFSC_code"
                  name="IFSC_code"
                  value={this.state.IFSC_code}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.IFSC_code ? 'is-invalid' : ''}`}
                  placeholder="Enter IFSC code"
                  required
                />
                {errors.IFSC_code && <div className="invalid-feedback">{errors.IFSC_code}</div>}
              </div>


              <div className="col-md-6 mb-3">
                <label htmlFor="account_Type" className="form-label">Account Type:</label>
                <Select
                  id="account_Type"
                  name="account_Type"
                  value={bankAccountType.find(option => option.value === this.state.bankaccount_Type)}
                  onChange={(selectedOption) => this.handleSelectChange('account_Type', selectedOption)}
                  options={bankAccountType}
                  placeholder="Select Account Type"
                  required
                />
                {errors.account_Type && <div className="text-danger">{errors.account_Type}</div>}
              </div>
            </div>

            {/* Fourth Column */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="salary_Mode_Of_Trasfer" className="form-label">Salary Mode Of Trasfer:</label>
                <Select
                  id="salary_Mode_Of_Trasfer"
                  name="salary_Mode_Of_Trasfer"
                  value={salaryTransferMode.find(option => option.value === this.state.salaryTransferMode)}
                  onChange={(selectedOption) => this.handleSelectChange('salary_Mode_Of_Trasfer', selectedOption)}
                  options={salaryTransferMode}
                  placeholder="Select Salary Mode"
                  required
                />
                {errors.salary_Mode_Of_Trasfer && <div className="text-danger">{errors.salary_Mode_Of_Trasfer}</div>}
              </div>


            </div>

          </form>
          <div className="d-flex justify-content-end" style={{ marginTop: "50px" }}>
            <button type="button" onClick={this.handleSubmit} className="btn btn-success btn-label waves-effect right waves-light">
              <i className="bx bx-save label-icon align-middle fs-16 ms-2" /> Save
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(EmployeeList);
